import React, { FC } from 'react';

import { UniversalFilterConstants } from '@app/hooks/use-filter-data';

import useTranslation from '@app/hooks/use-translation';

import { Edit3Icon, Edit2Icon } from '../../icons/icons-list';
import { Filter, FilterItem, FilterQmOperatorsType, FilterUcid, Range } from '../types';
import { OptionItem } from '../../select/select.type';
type ModalModeFilterViewPropsType = {
  filterData: Filter & Range & Partial<FilterQmOperatorsType> & FilterUcid;
  getNameByValueKey(key: string): string;
  teamsAndOperatorsDataForFilter?: Record<'qm_teams' | 'qm_operators', OptionItem[]>;
  changeFilterModalState(): void;
  disabledChangeButton: boolean;
  modalModeStyle: 'first' | 'second';
};
const ModalModeFilterView: FC<ModalModeFilterViewPropsType> = (props) => {
  const {
    filterData,
    getNameByValueKey,
    teamsAndOperatorsDataForFilter,
    changeFilterModalState,
    disabledChangeButton,
    modalModeStyle,
  } = props;

  const { t } = useTranslation('components.filter');

  function getOperatorNameByValueKey(key: string) {
    if (!teamsAndOperatorsDataForFilter) return;
    return (
      (Object.values(teamsAndOperatorsDataForFilter || {}).flat(Infinity) as OptionItem[]).find(
        (item) => item.value === key,
      )?.title || 'N/A'
    );
  }

  const operatorsMarkup = filterData?.operators?.map((filter, index) => (
    <div key={index} className={'relative  flex items-center '}>
      {filter.value && (
        <div className="min-w-max pr-[6px] text-[15px] leading-[18px] ">
          {getOperatorNameByValueKey(filter.value[0])}
        </div>
      )}
    </div>
  ));

  const modalModeMarkup = {
    first: (
      <div>
        <div
          className={`flex w-full truncate relative  border-[1px] border-solid h-[32px] px-[12px] rounded-defaultR`}
        >
          {filterData?.filter.map((filter, index) => {
            if (Array.isArray(filter)) {
              return filter.map((filterItem, indexItem) => (
                <FirstModeView
                  key={indexItem}
                  filter={filterItem}
                  getNameByValueKey={getNameByValueKey}
                  valLength={filterItem[indexItem]?.value.length}
                />
              ));
            }
            return (
              <FirstModeView
                key={index}
                filter={filter}
                getNameByValueKey={getNameByValueKey}
                valLength={filter[index]?.value.length}
              />
            );
          })}
          {/* TODO: */}
          {operatorsMarkup}
        </div>
        <div
          onClick={() => changeFilterModalState()}
          className={
            '!text-action cursor-pointer flex items-center justify-end gap-[3px] self-end mt-[5px] '
          }
        >
          <Edit3Icon className={'text-action'} size={13} />
          <span className={'text-[13p] font-[500] tracking-tight leading-[110%]'}>
            {t('change')}
          </span>
        </div>
      </div>
    ),
    second: (
      <div className="bg-defaultBg border-l-speech_analitics border-l-[2px] p-[6px] relative rounded-[12px] ">
        <div className={`w-full bg-white  h-[43px] p-[6px_12px] rounded-[12px]`}>
          <div className="flex items-center h-full truncate w-[calc(100%-40px)]">
            {filterData?.filter.map((filter, index) => {
              if (Array.isArray(filter)) {
                return filter.map((filterItem, indexItem) => (
                  <SecondModeView
                    key={indexItem}
                    filter={filterItem}
                    getNameByValueKey={getNameByValueKey}
                    valLength={filterItem[indexItem]?.value.length}
                  />
                ));
              }
              return (
                <SecondModeView
                  key={index}
                  filter={filter}
                  getNameByValueKey={getNameByValueKey}
                  valLength={filter[index]?.value.length}
                />
              );
            })}
            {/* TODO: */}
          </div>
          {operatorsMarkup}
        </div>
        <div
          onClick={() => !disabledChangeButton && changeFilterModalState()}
          className={`${
            disabledChangeButton
              ? ' text-3color border-3color  cursor-not-allowed'
              : ' text-action border-action cursor-pointer'
          } absolute right-0 top-[50%] z-[10] translate-x-[-50%] translate-y-[-50%]  flex items-center justify-center p-2 border-solid border-[1px]  rounded-defaultR`}
        >
          <Edit2Icon className={disabledChangeButton ? 'text-3color' : 'text-action'} size={15} />
        </div>
      </div>
    ),
  };
  return modalModeMarkup[modalModeStyle];
};

export default ModalModeFilterView;

const FirstModeView = ({
  filter,
  getNameByValueKey,
  valLength,
}: {
  filter: FilterItem;
  getNameByValueKey: (key: string) => string;
  valLength: number;
}) => {
  const { conditionsWithoutValue, conditionsWithoutValueDisplay } = UniversalFilterConstants();
  const { t } = useTranslation('components.filter');

  return (
    <div className={'relative  flex items-center '}>
      {filter.id && (
        <div className="min-w-max pr-[6px] text-[15px] leading-[18px] ">
          {getNameByValueKey(filter.id)}
        </div>
      )}
      {filter.condition && (
        <div className="flex justify-center items-center w-[22px] h-[22px]  text-2color text-[15px] leading-[16px] mr-[6px] pb-[2px] border border-b_dark rounded-full">
          {conditionsWithoutValue.includes(filter.condition)
            ? conditionsWithoutValueDisplay[filter.condition] || 'e'
            : filter.condition}
        </div>
      )}
      <div className={'pr-[16px] flex items-center gap-[5px]'}>
        {Array.isArray(filter.value) ? (
          filter.value.map(
            (value, indexValue) =>
              value && (
                <div className={'flex items-center'} key={indexValue}>
                  {indexValue <= value.length - 1 && indexValue === 0 && (
                    <div className={'pr-1.5'}>(</div>
                  )}
                  <div
                    className={
                      'bg-defaultBg w-fit text-[15px] leading-[18px] text-2color px-[8px] pt-[2px] pb-[3px] rounded-[4px]'
                    }
                  >
                    {value}
                  </div>
                  {indexValue < valLength - 1 && (
                    <div className="px-[4px] text-[15px] leading-[18px] ml-[5px] border rounded-full text-2color">
                      {t('or')}
                    </div>
                  )}
                  {indexValue === valLength - 1 && <div className={'pl-1.5'}>)</div>}
                </div>
              ),
          )
        ) : (
          <div
            className={
              'bg-defaultBg px-[8px] pt-[2px] pb-[3px] rounded-[4px] w-fit text-[15px] leading-[18px] text-2color'
            }
          >
            {filter.value}
          </div>
        )}
      </div>
    </div>
  );
};

const SecondModeView = ({
  filter,
  getNameByValueKey,
  valLength,
}: {
  filter: FilterItem;
  getNameByValueKey: (key: string) => string;
  valLength: number;
}) => {
  const { conditionsWithoutValue, conditionsWithoutValueDisplay } = UniversalFilterConstants();
  const { t } = useTranslation('components.filter');

  return (
    <div className={'relative  flex items-center '}>
      {filter.id && (
        <div className="min-w-max pr-[6px] text-[15px] leading-[18px] ">
          {getNameByValueKey(filter.id)}
        </div>
      )}
      {filter.condition && (
        <div className="flex justify-center items-center w-[22px] h-[22px]  text-2color text-[15px] leading-[16px] mr-[6px] pb-[2px] border border-b_dark rounded-full">
          {conditionsWithoutValue.includes(filter.condition)
            ? conditionsWithoutValueDisplay[filter.condition] || 'e'
            : filter.condition}
        </div>
      )}
      <div className={'pr-[16px] flex items-center gap-[5px]'}>
        {Array.isArray(filter.value) ? (
          filter.value.map(
            (value, indexValue) =>
              value && (
                <div className={'flex items-center'} key={indexValue}>
                  {indexValue <= value.length - 1 && indexValue === 0 && (
                    <div className={'pr-1.5'}>(</div>
                  )}
                  <div
                    className={
                      'bg-defaultBg w-fit text-[15px] leading-[18px] text-2color px-[8px] pt-[2px] pb-[3px] rounded-[4px]'
                    }
                  >
                    {value}
                  </div>
                  {indexValue < valLength - 1 && (
                    <div className="px-[4px] text-[15px] leading-[18px] ml-[5px] border rounded-full text-2color">
                      {t('or')}
                    </div>
                  )}
                  {indexValue === valLength - 1 && <div className={'pl-1.5'}>)</div>}
                </div>
              ),
          )
        ) : (
          <div
            className={
              'bg-defaultBg px-[8px] pt-[2px] pb-[3px] rounded-[4px] w-fit text-[15px] leading-[18px] text-2color'
            }
          >
            {filter.value}
          </div>
        )}
      </div>
    </div>
  );
};
